__webpack_require__.p = "https://hsc.unm.edu/about/wellness/artwalk/";